import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { WsApiKeysModel } from './models/ws-api.keys';

@Component({
  selector   : 'ws-api-secret-key',
  template: require('./ws-api.secret-key.component.html')
})
export class WsApiSecretKeyComponent {
  @Input() keys : WsApiKeysModel;

  constructor (
    public activeModal      : NgbActiveModal
  ) {}
}
